import React from 'react'
import ProfilePic from "../assets/images/Profile_Pic_edited.png"
import {HiArrowNarrowRight} from 'react-icons/hi'

const Home = () => {
    // var text = document.getElementById('angled_text');
    // var name = document.getElementById('name');
    // var intro = document.getElementById('intro');
    // var shadow = '';

    // for( var i = 0; i < 5; i++) {
    //     shadow += (shadow? ',' : '') + -i + 'px ' + -i + 'px 0'
    // }

    // intro.style.textShadow = shadow;
    // name.style.textShadow = shadow;

    // function setHeight(){
    //     document.body.style.height = String(parseInt(window.innerHeight, 10) - 80) + "px";
    //     // console.log(document.body.style.height)
    //     console.log(document.body.style.height)
    // }

    // window.addEventListener("resize", setHeight);
    // setHeight();

  return (
    <div name='home' className='w-full h-[calc(100dvh-80px)] pb-10 lg:px-28 bg-gradient-to-tr from-[#010000] to-[#020933] lg:h-[calc((100dvh-80px)/2)]'>

      <div className='flex flex-col gap-10 px-10 py-10 h-full justify-evenly items-center lg:flex-row lg:items-center'>
        {/* flex h-full px-[100px] gap-20 md: */}
        
        <div className='flex flex-col justify-center gap-5'>
            <h1 id='name' className='mobile_title justify-start lg:title'>Hi, I'm Robert</h1>
            <h1 id='intro' className='mobile_subheading'>I'm a mechanical engineering student at the <a href='https://www.me.utexas.edu/' target='_blank' className=' text-[#d16e11] hover:brightness-150'>University of Texas at Austin</a>, specializing in automotive and software engineering</h1>
        </div>
        
        <div className='flex justify-center items-center lg:flex-shrink-0'>
          <img src={ProfilePic} alt="logo" className='w-[225px] rounded-3xl sm:w-[300px]'/>
          {/* <p id='angled_text' className=' relative text-white text-3xl rotate-light-z'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> */}
        </div>

      </div>

    </div>
  )
}

export default Home